import { Component, ElementRef, HostBinding, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Location } from '@angular/common';
import moment from 'moment';
import momentJalaali from 'moment-jalaali';
import Target from 'ol/events/Target';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as XLSX from 'xlsx';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;

@Component({

  selector: 'supportManager',

  templateUrl: './supportManager.component.html',

})

export class SupportManagerComponent implements OnInit {

  constructor(

    private el: ElementRef,

    private notifyService: NotificationService,

    private router: Router,

    private otherService: OtherService,

    private route: ActivatedRoute,

    private formBuilder: FormBuilder,

    private _location: Location,

    private deviceService: DeviceDetectorService,

    private gurdService: GurdServiceService

  ) { }

  Support: any;

  ServiceTxt: any;

  singelSupport: any;

  Actions: any;

  answerList: any;

  deviceInfo: boolean = false;

  fullSupport: any;

  tiketSubject: any;

  tiketStatus: any;

  fileName = 'ExcelSheet.xlsx';

  car: any;

  sabtModel: FormGroup = this.formBuilder.group({

    tiTiketStatus: new FormControl("-1"),

    strActionDetail: new FormControl(""),

    iTiket: new FormControl(),

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

  });

  sendSmsModel: FormGroup = this.formBuilder.group({

    iTiket: new FormControl(),

    strMobile: new FormControl(),

    strSystemUser_strMobile: new FormControl(),

    strMessage: new FormControl(""),

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

  });

  ngOnInit(): void {

    this.deviceInfo = this.deviceService.isDesktop();

    this.getAllSupport();

    this.getTiketSubject();

    this.getTiketStatus();

    this.getTicketAnswer();
  }

  goBack() {
    this._location.back();
  }

  getAllSupport = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      tiTiketStatus: -1,
      tiTiketSubject: -1,
      strDate: "",
    }
    this.otherService.Showspinner();
    const resp = await axios.post(
      `Tiket_GetTiket4Support`, model
    );
    this.otherService.nonespinner();
    resp.data = JSON.parse(resp.data);
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;
    }
    if (resp.data.length == 0) {
      this.notifyService.showInfo('داده ای برای نمایش موجود نیست', '');
      this.Support = resp.data;
    } else {
      this.Support = resp.data;
      this.fullSupport = resp.data;
    }
  };

  singel = async (i: any) => {
    this.singelSupport = this.Support[i];
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iTiket: this.singelSupport.iTiket
    }
    const resp = await axios.post(
      `Tiket_GetTiketAction4Support`, model
    );
    this.Actions = JSON.parse(resp.data);
  }

  seprator(e: any) {
    this.otherService.insertComma(e);
  }

  sabt = async () => {

    this.sabtModel.controls["iTiket"].setValue(this.singelSupport.iTiket);

    var model = this.sabtModel.value;

    if (model.tiTiketStatus == -1) {

      this.notifyService.showError("لطفا نوع اقدام را مشخص کنید");

      return;
    }

    const resp = await axios.post(
      `Tiket_SaveTiketAction`, this.sabtModel.value
    );
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);

    }
    else {
      $("#exampleModal2").modal("hide");
      this.sabtModel.controls["tiTiketStatus"].setValue("-1");
      this.sabtModel.controls["strActionDetail"].setValue("");
      this.notifyService.showSuccess("با موفقیت ثبت شد");
      var strComment = this.answerList.filter((el: any) => {
        return el.tiTiketStatus == model.tiTiketStatus;
      });
      this.Support.forEach((el: any) => {
        if (el.iTiket == this.singelSupport.iTiket) {
          el.tiTiketStatus = model.tiTiketStatus;
          el.strTiketStatus_strComment = strComment[0].strComment;
        }
        return el;
      });
      this.fullSupport.forEach((el: any) => {
        if (el.iTiket == this.singelSupport.iTiket) {
          el.tiTiketStatus = model.tiTiketStatus;
          el.strTiketStatus_strComment = strComment[0].strComment;
        }
        return el;
      });
      //this.getAllSupport();
    }
  }

  getTiketSubject = async () => {

    const resp = await axios.post(
      `Tiket_GetTiketSubjects`,
    );
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;
    }
    else {
      this.tiketSubject = resp.data;

    }
  };

  getTiketStatus = async () => {

    const resp = await axios.post(
      `Tiket_GetTiketStatus`,
    );
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;
    }
    else {
      this.tiketStatus = resp.data;


    }
  };

  filterSubject(val: any) {
    if (val.value == -1) {
      this.Support = this.fullSupport;
      return;
    }
    this.Support = this.fullSupport.filter((el: any) => {
      return el.tiTiketSubject == val.value;
    });
  }

  filterStatus(val: any) {
    if (val.value == -1) {
      this.Support = this.fullSupport;
      return;
    }
    this.Support = this.fullSupport.filter((el: any) => {
      return el.tiTiketStatus == val.value;
    });
  }

  baseOnId(val: any) {
    if (val.value == "") {
      this.Support = this.fullSupport;
      return;
    }
    this.Support = this.fullSupport.filter((el: any) => {
      return el.iTiket == val.value;
    });
  }

  sortByName() {
    this.Support.sort((a: any, b: any) => {
      var textA = a.strFullName.toUpperCase();
      var textB = b.strFullName.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }

  sortById() {
    this.Support.sort((a: any, b: any) => {
      var textA = a.iTiket;
      var textB = b.iTiket;
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }

  getTicketAnswer = async () => {
    const resp = await axios.post(
      `Tiket_GetTiketStatus4Support`, {}
    );
    this.answerList = JSON.parse(resp.data)

  }

  sendSms = async () => {
    this.sendSmsModel.controls["iTiket"].setValue(this.singelSupport.iTiket);
    this.sendSmsModel.controls["strSystemUser_strMobile"].setValue(this.singelSupport.strSystemUser_strMobile);
    this.sendSmsModel.controls["strMobile"].setValue(this.singelSupport.strMobile);
    var model = this.sendSmsModel.value;
    if (model.strMessage == "") {
      this.notifyService.showError("متن پیام نباید خالی باشد");
      return;
    }
    const resp = await axios.post(
      `Tiket_SendSMS`, model
    );
    resp.data = JSON.parse(resp.data);
    this.sendSmsModel.controls["strMessage"].setValue("");
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;
    }
    else {
      this.notifyService.showSuccess("با موفقیت ارسال شد");
    }


  }

  getDeviceInfo = async (Id: any) => {

    this.otherService.Showspinner();
    var model = {
      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    };
    const resp = await axios.post(
      `GetCar?strUnitID=${Id}`,
      model
    );
    this.otherService.nonespinner();

    if (resp.data.ISSessionExpired == true) {
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    if (resp.data == null) {
      this.notifyService.showError('بروز خطا در سامانه');
      return;
    }

 else {
      this.car = resp.data;
      // this.car = resp.data;
      // this.filterCar = resp.data;
      // this.carNumber = resp.data.length;
    }


  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }
}
